// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"73":"6352922e","153":"c828862e","237":"01f42fc9","448":"3c90d983","567":"c12b4b25","575":"5932f4d3","678":"979369ff","725":"26e9ca21"}[chunkId] + ".chunk.js";
};